export default __webpack_public_path__ + "static/media/fixed-income.d85c0da7.svg";